import React from "react";

import { Routes, Route } from "react-router-dom";

import PageNoteFound from "components/Common/PageNotFound";

import AnalysisHome from "./Home";
import Results from "./Results";

const ApproachableAI = () => (
  <Routes>
    <Route path="/" element={<AnalysisHome />} />
    <Route path=":analysisId/*" element={<Results />} />
    <Route path="*" element={<PageNoteFound />} />
  </Routes>
);

export default ApproachableAI;
